// src/ds/MoneyText.tsx
// Amounts always render with currency + tabular figures — never a bare number.
import React from "react";
import type { Currency } from "./types";
import { money } from "./format";

export interface MoneyTextProps {
  amount: number;
  currency: Currency;
  /** show the ISO code after the amount (e.g. "R1,515,600.00 ZAR") */
  withCode?: boolean;
  bold?: boolean;
  style?: React.CSSProperties;
}

export function MoneyText({
  amount,
  currency,
  withCode,
  bold,
  style,
}: MoneyTextProps) {
  return (
    <span
      style={{
        fontVariantNumeric: "tabular-nums",
        fontWeight: bold ? 700 : 600,
        ...style,
      }}
    >
      {money(amount, currency)}
      {withCode && currency !== "USDC" ? ` ${currency}` : ""}
    </span>
  );
}

export default MoneyText;
